import { useAxiosClient } from '../axios/client'
import type {AllmaJob} from '~/models/allmajob'

const { axiosClient } = useAxiosClient()

export const allmaJobsGetById = async (params: Record<string, any>): Promise<AllmaJob> => {
  const jobs = (await axiosClient.value.get<AllmaJob>(`/v1/allmajobs/${params.id}?update=${params.update}`)).data
  return jobs
}
